import { format } from 'date-fns';

// Philippines is fixed at UTC+8 (no DST).
const PH_OFFSET_MS = 8 * 60 * 60 * 1000;

// Returns the PH wall-clock date/time components for a given JS Date.
function getPhDateParts(now) {
  const source = now instanceof Date ? now : new Date();
  const shifted = new Date(source.getTime() + PH_OFFSET_MS);
  return {
    year: shifted.getUTCFullYear(),
    month: shifted.getUTCMonth(),
    day: shifted.getUTCDate(),
    hours: shifted.getUTCHours(),
    minutes: shifted.getUTCMinutes(),
    seconds: shifted.getUTCSeconds(),
  };
}

// Returns a JS Date whose valueOf() represents the current PH wall-clock time.
function getPhNow() {
  const parts = getPhDateParts(new Date());
  return new Date(Date.UTC(parts.year, parts.month, parts.day, parts.hours, parts.minutes, parts.seconds) - PH_OFFSET_MS);
}

// Returns a JS Date whose valueOf() represents PH midnight today.
function getPhToday() {
  const phDateString = new Date().toLocaleDateString('en-CA', {
    timeZone: 'Asia/Manila',
  }); // Returns "YYYY-MM-DD"

  // Create a date object representing midnight in Manila time
  return new Date(`${phDateString}T00:00:00`);
}

// Formats a JS Date using its PH wall-clock fields. Use this instead of
// date-fns `format()` when you want the formatted string to reflect PH time
// regardless of the user's system timezone.
function formatInPhTime(date, fmt) {
  const source = date instanceof Date ? date : new Date();
  const parts = getPhDateParts(source);
  const shifted = new Date(Date.UTC(parts.year, parts.month, parts.day, parts.hours, parts.minutes, parts.seconds) - PH_OFFSET_MS);
  return format(shifted, fmt);
}

/**
 * Today's PH calendar date as a 'yyyy-MM-dd' string.
 *
 * The same shape bookings store in their `date` child, so this compares
 * directly against one — and works as a Firebase startAt/endAt bound on that
 * index, since those keys sort lexicographically.
 *
 * @returns {string} e.g. '2026-09-15'
 */
function phTodayStr() {
  // en-CA formats as YYYY-MM-DD, which is what makes the result comparable as
  // a plain string without going through a Date at all.
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Manila' });
}

const phTime = { getPhNow, getPhToday, formatInPhTime, phTodayStr };

export { getPhNow, getPhToday, formatInPhTime, phTodayStr };
export default phTime;
